import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=d553d1b4&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=d553d1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d553d1b4",
  null
  
)

export default component.exports